// i18next bootstrap. Imported once for side effects from src/frontend.tsx
// before the React tree mounts so first paint already has translations
// available. Components consume via `useTranslation()` from
// `react-i18next`. Generated by step 005-i18n based on args.locales.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ru from "./locales/ru.json";

// Консоль работает ТОЛЬКО на русском (по требованию): язык жёстко зафиксирован,
// детектор языка и переключатель убраны. En-словарь больше не подключаем.
void i18n.use(initReactI18next).init({
	resources: {
		ru: { translation: ru },
	},
	lng: "ru",
	fallbackLng: "ru",
	supportedLngs: ["ru"],
	interpolation: { escapeValue: false },
});

export default i18n;
